import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauthenticated
  const [branches, setBranches] = useState([]);
  const [activeBranch, setActiveBranch] = useState(null);

  const loadBranches = useCallback(async () => {
    try {
      const { data } = await api.get("/branches");
      setBranches(data);
      return data;
    } catch {
      return [];
    }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("og_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const bs = await loadBranches();
      const stored = localStorage.getItem("og_branch");
      const isSuper = (data.permissions || []).includes("*");
      const pick = (isSuper && bs.some((b) => b.id === stored) ? stored : null) || data.branch_id || (bs[0] && bs[0].id) || null;
      setActiveBranch(pick);
      if (pick) localStorage.setItem("og_branch", pick); else localStorage.removeItem("og_branch");
    } catch {
      localStorage.removeItem("og_token");
      setUser(false);
    }
  }, [loadBranches]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("og_token", data.access_token);
    localStorage.removeItem("og_branch");
    setUser(data.user);
    const bs = await loadBranches();
    const pick = data.user.branch_id || (bs[0] && bs[0].id) || null;
    setActiveBranch(pick);
    if (pick) localStorage.setItem("og_branch", pick);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("og_token");
    localStorage.removeItem("og_branch");
    setUser(false);
  };

  const selectBranch = (id) => {
    setActiveBranch(id);
    localStorage.setItem("og_branch", id);
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ user, setUser, branches, activeBranch, selectBranch, login, logout, refreshBranches: loadBranches }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
